import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import { ScheduledMessage, ScheduledMessageSortOption } from '../requests/get-scheduled-messages';

export const scheduledMessagesAtomFamily = atomFamily((_chatId: string) => atom<ScheduledMessage[]>([]));

export const scheduledMessagesSortOptionAtom = atom<ScheduledMessageSortOption>('dateUpdated');
